import { CREATE_FAVOURITE_TO_OBJECT } from "./actionTypes";

export default (objectId: Number, objectType: String, thumbnail) => ({
  type: CREATE_FAVOURITE_TO_OBJECT,
  payload: {
    objectId,
    objectType,
    thumbnail
  },
});